<app-dea-widget-wrapper>
  <div *ngIf="loading" class="d-flex justify-content-center align-items-center" style="height: 96px;">
    <mat-spinner strokeWidth="2" color="primary" diameter="40"></mat-spinner>
  </div>
  <div *ngIf="!loading && error" class="d-flex justify-content-center align-items-center" style="height: 96px;">
    {{error.message}}
  </div>
  <div *ngIf="!loading && !error && license" class="m-0 p-0">
    <div class="mb-3 border dea-radius p-3">
      <div class="d-flex flex-row gap-3">
        <div class="pt-2">
          <img src="{{license.favicon}}" alt="{{license.title}}" height="32" width="32" />
        </div>
        <div class="d-flex flex-column gap-2 flex-grow-1 pt-2">
          <div class="fw-bold" style="font-size: 1.3rem;">{{license.title}}</div>
          <div *ngIf="license.private_key || license.key" class="d-flex flex-column gap-1">
            <div *ngIf="license.private_key" class="col m-0 p-0">Chiave Privata: {{license.private_key}}</div>
            <div *ngIf="license.key" class="col m-0 p-0">Chiave Condivisa: {{license.key}}</div>
          </div>
          <div class="d-flex flex-row gap-3">
            <div class="col m-0 p-0">Inizio: {{license.start ? (license.start | date:'yyyy-MM-dd') : ' -'}}</div>
            <div class="col m-0 p-0">Fine: {{license.end ? (license.end | date:'yyyy-MM-dd') : ' -'}}</div>
          </div>
          <div *ngIf="license.instructions" class="d-flex flex-row gap-3">
            {{license.instructions}}
          </div>
        </div>
        <div class="d-flex flex-column justify-content-between">
          <div class="d-flex flex-row justify-content-end gap-2">
            <a href="{{license.dashboard_link}}" target="_blank" referrerpolicy="no-referrer">
              <button *ngIf="license.dashboard_link" class="d-flex align-items-center dea-icon-btn dea-pointer"
                mat-icon-button title="Apri Dashboard: {{license.dashboard_link}}" color="secondary">
                <i class="bi bi-link-45deg"></i>
              </button>
            </a>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row justify-content-end gap-3">
        <app-dea-chip-status title="Visualizza Dettagli" [label]="'Assegnate: '+license.activeAssignmentsCount"
          [status]="true">
        </app-dea-chip-status>
      </div>
    </div>
  </div>
  <div class="v-spacer"></div>
  <!-- LISTING -->
  <div *ngIf="license">
    <div *ngIf="listingLoading" class="d-flex justify-content-center align-items-center" style="height: 96px;">
      <mat-spinner strokeWidth="2" color="primary" diameter="40"></mat-spinner>
    </div>
    <div *ngIf="!listingLoading && listingError" class="d-flex justify-content-center align-items-center"
      style="height: 96px;">
      {{listingError.message}}
    </div>
    <div *ngIf="!listingLoading && !listingError" class="m-0 p-0">
      <table class="table table-borderless m-0">
        <thead class="m-0">
          <tr class="dea-table-row-header m-0">
            <th scope="col"></th>
            <th scope="col-3">Cognome</th>
            <th scope="col-3">Nome</th>
            <th scope="col-3">Secondo Nome</th>
            <th scope="col-auto">Data Creazione</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let licenseAssignment of licenseAssignmentsListing;" class="user-listing-table-row dea-radius">
            <td class="col" routerLink="/utente/{{licenseAssignment.user?.id}}"
              title="{{licenseAssignment.user?.getFullName()}}">
              <app-dea-thumbnail-img size="32" id="{{licenseAssignment.user?.id}}"></app-dea-thumbnail-img>
            </td>
            <td class="col-3 py-auto" routerLink="/utente/{{licenseAssignment.user?.id}}"
              title="{{licenseAssignment.user?.getFullName()}}">
              {{licenseAssignment.user?.cognome}}
            </td>
            <td class="col-3 py-auto" routerLink="/utente/{{licenseAssignment.user?.id}}"
              title="{{licenseAssignment.user?.getFullName()}}">
              {{licenseAssignment.user?.nome}}
            </td>
            <td class="col-3 py-auto" routerLink="/utente/{{licenseAssignment.user?.id}}"
              title="{{licenseAssignment.user?.getFullName()}}">
              {{licenseAssignment.user?.secondo_nome}}
            </td>
            <td class="col-auto py-auto" routerLink="/utente/{{licenseAssignment.user?.id}}"
              title="{{licenseAssignment.user?.getFullName()}}">
              {{licenseAssignment.createdAt | date:'yyyy-MM-dd'}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <app-listing-pagination-bar [paginationData]="pagination"
      (pageEmitter)="onPage($event)"></app-listing-pagination-bar>
  </div>
</app-dea-widget-wrapper>